import {memo, ReactNode} from 'react';
import styled from 'styled-components';
import {MOBILE_BREAKPOINT} from './constants';

interface CardContentProps {
  children: ReactNode;
}

export const CardContent = memo(({children}: CardContentProps) => {
  return (
    <ContentWrapper>
      <Content>{children}</Content>
    </ContentWrapper>
  );
});

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  padding-left: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  flex: 1;
  width: 100%;
  min-width: 0;

  /* Mobile responsiveness */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-left: 0;
    flex-direction: column;
    gap: 12px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;
  flex: 1;
  width: 100%;
  min-width: 0;

  /* Mobile responsiveness */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: auto;
    gap: 12px;
  }
`;
